import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { environment } from '../../environments/environment';
import Swal from 'sweetalert2';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Injectable({
	providedIn: 'root',
})
export class SessionService {
	// months: { monthId: string; monthName: string; }[];
	months: { monthId: string; monthName: string }[] = [];
	taxMonths: { month: string; monthName: string }[] = [];
	taxes: string[] = [];
	apiUrl: string;

	private_laboratory_appId = environment.APP_ID_PRIVATE_LABORATORY;
	collection_center_appId = environment.APP_ID_COLLECTION_CENTER;
	airport_personnal_appId = environment.APP_ID_AIRPORT_PERSONAL;
	health_ministry_appId = environment.APP_ID_MINISTRY_OF_HEALTH;

	constructor(
		private router: Router,
		private location: Location,
		private httpClient: HttpClient,
		private spinnerService: Ng4LoadingSpinnerService
	) {}

	validtoken: any;
	application_id: any;

	selfportal_application_id = environment.APPLICATION_ID;

	public checkLogin() {
		this.validtoken = localStorage.getItem('access_token');
		this.application_id = localStorage.getItem('application_id');

		// console.log("token: ", this.validtoken);
		if (this.validtoken == '' || this.validtoken === null) {
			this.router.navigate(['/login']);
		}
	}

	public confirmUser(userAppId: any, appId: any, appName: string) {
		if (userAppId != appId) {
			console.log('user unauthorized');
			Swal.fire({
				icon: 'info',
				title: 'INFORMATION',
				text:
					'You are not authorized to access this page. Only for ' +
					appName +
					' users',
				showConfirmButton: true,
				timer: 5000,
				timerProgressBar: true,
			});
			this.logOut();
			return;
		}
	}

	public logOut() {
		localStorage.clear();
		this.router.navigate(['/home']);
		// this.router.navigate(['/signup']);
	}

	public islogin() {
		this.validtoken = localStorage.getItem('access_token');
		this.application_id = localStorage.getItem('application_id');

		if (
			this.validtoken != null &&
			this.application_id == this.private_laboratory_appId
		) {
			this.router.navigate(['/lab-dashboard']);
		}
		if (
			this.validtoken != null &&
			this.application_id == this.collection_center_appId
		) {
			this.router.navigate(['/sample-center-dashboard']);
		}
		if (
			this.validtoken != null &&
			this.application_id == this.health_ministry_appId
		) {
			this.router.navigate(['/ministry-dashboard']);
		}
		if (
			this.validtoken != null &&
			this.application_id == this.airport_personnal_appId
		) {
			this.router.navigate(['/airport-dashboard']);
		}
	}
}
